// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-scrollbar__wrap{width:300px;height:200px}.zhs-no-data .label{font-size:14px}.teacher-dialog .el-dialog__body{padding:12px 24px 24px}", ""]);
// Exports
module.exports = exports;
